import { Injectable } from '@angular/core';
import { Observable, Observer, from, of } from 'rxjs';
import { catchError, concatMap, take } from 'rxjs/operators';

const maxQuestionaireFileZize=5;

const INVALID_FILE = ' Invalid file.';
const INVALID_IMAGE = ' Invalid image.';
const INVALID_SIZE=`File size exceeds ${maxQuestionaireFileZize} MB.`;
@Injectable({
  providedIn: 'root'
})
export class ImageUploaderService {

  constructor() { }
  uploadFiles(event: any) {
    const files = event?.target?.files;
    const numberOfFiles = files.length;
    return from(files)
      .pipe(
        concatMap((file: any) => this.validateFile(file).pipe(catchError((error: any) => of(error)))),
        take(numberOfFiles)
      );
  }

  public validateFile(file: File): Observable<any> {
    const fileReader = new FileReader();
    const { type, name } = file;
    return new Observable((observer: Observer<any>) => {
      this.validateSize(file, observer);
      fileReader.readAsDataURL(file);
      fileReader.onload = event => {
        if (this.isImage(type)) {
          const image = new Image();
          image.onload = () => {
            observer.next({ file: file, base64: fileReader.result });
            observer.complete();
          };
          image.onerror = () => {
            observer.error({ error: { name, errorMessage: INVALID_IMAGE } });
          };
          image.src = fileReader.result as string;
        } else {
          observer.next({ file: file, base64: fileReader.result });
          observer.complete();
        }
      };
      fileReader.onerror = () => {
        observer.error({ error: { name, errorMessage: INVALID_FILE } });
      };
    });
  }

  private isImage(mimeType: string): boolean {
    return mimeType.match(/image\/*/) !== null;
  }

  private validateSize(file: File, observer: Observer<any>): void {
    const { name, size } = file;
    if (this.isValidSize(file)) {
      observer.error({ error: { name, errorMessage: INVALID_SIZE } });
    }
  }

  private isValidSize(file: any): boolean {
    // const toKByte = size / 1024;
  console.log(file);

    const maxFileSizeBytes = maxQuestionaireFileZize * 1024 * 1024; // Convert MB to Bytes
    // return (file?.height > 90) && (file?.width > 90);
    return file.size>maxFileSizeBytes;
  }


}
